import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";
import { Footer } from "@/components/site/Footer";

export const LegalLayout = ({ title, updated, testid, children }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="relative min-h-screen bg-[#05050c]" data-testid={testid}>
      <header className="sticky top-0 z-50 border-b border-white/10 bg-[#05050c]/85 backdrop-blur-xl">
        <div className="max-w-4xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3" data-testid="legal-logo-home">
            <img src="/mobyle-logo.png" alt="Mobyle" className="h-9 w-auto object-contain" />
            <span className="font-heading font-extrabold text-xl tracking-tight text-white">Mobyle</span>
          </Link>
          <Link
            to="/"
            className="group inline-flex items-center gap-2 text-sm text-white/60 hover:text-teal transition-colors duration-300"
            data-testid="legal-back-home"
          >
            <ArrowLeft size={16} className="group-hover:-translate-x-1 transition-transform duration-300" />
            Back to home
          </Link>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 py-16 md:py-24">
        <span className="text-xs uppercase tracking-[0.25em] text-teal/80">Legal</span>
        <h1 className="mt-5 font-heading font-extrabold tracking-tighter text-white text-4xl sm:text-5xl">
          {title}
        </h1>
        <p className="mt-4 text-sm text-white/40">Last updated: {updated}</p>
        <div className="mt-12 space-y-10 leading-relaxed">{children}</div>
      </main>

      <Footer />
    </div>
  );
};

export const LegalSection = ({ heading, children }) => (
  <section className="space-y-3">
    <h2 className="font-heading font-bold text-white text-xl md:text-2xl">{heading}</h2>
    <div className="space-y-3 text-white/65">{children}</div>
  </section>
);
